export const screenName = 'CustomerAssetDetail';
